<a
  class="link"
  [class.link--small]="isChildItem() && !isExpanded()"
  matRipple
  [routerLink]="[path()]"
  [routerLinkActive]="'link--active'"
  [routerLinkActiveOptions]="{ exact: path() === '/' }"
  (click)="rla.isActive || emitItemClick()"
  #rla="routerLinkActive"
  #link
>
  @if (isChildItem() && isExpanded()) {
    <div class="link__child-item-line"></div>
  }

  <mat-icon class="link__icon" [class]="rla.isActive ? '' : 'material-icons-outlined'">
    {{ icon() }}
  </mat-icon>

  <div class="link__label truncate">{{ label() }}</div>
</a>
